import BaseModal from "../BaseComponents/BaseModal/BaseModal";
import styles from "./UnsubscribeModal.module.css";

const UnsubscribeModal = ({ open, onClose, data, onConfirm }) => {
  if (!data) return null;

  const confirm = () => {
    onConfirm?.();
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Unsubscribe Subscriber"
      width="480px"
      footer={
        <>
          <button className={styles.cancel} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.confirm} onClick={confirm}>
            Unsubscribe
          </button>
        </>
      }
    >
      <p className={styles.text}>
        Are you sure you want to unsubscribe
        <b> {data.email}</b>?
      </p>
    </BaseModal>
  );
};

export default UnsubscribeModal;
